import App from "@/views/App.vue";

export default [
  {
    path: "",
    name: "login",
    component: App,
    redirect: { name: "loginUserPage" },
    children: [
      {
        path: "/onboarding/:user/:language?/:redirect_to?/:redirect_params?/:redirect_params_last?",
        name: "onboardingPage",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Onboarding.vue"),
        meta: {
          displayName: "displayName.onboarding",
          requiresAuth: false,
        },
      },
      {
        path: "/login",
        name: "loginUserPage",
        alias: "/",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/LoginUser.vue"),
        meta: {
          displayName: "displayName.login",
          requiresAuth: false,
        },
      },
      {
        path: "/login-empresa",
        name: "loginCompanyPage",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/LoginCompany.vue"),
        meta: {
          displayName: "displayName.login",
          requiresAuth: false,
        },
      },
    ],
  },
];
